import { UploadBadgeButtonField } from './UploadBadgeButtonField'
import { withUploadBadgeButtonField } from './withUploadBadgeButtonField'

const ConnectedUploadBadgeButtonField = withUploadBadgeButtonField(
  UploadBadgeButtonField
)

export { ConnectedUploadBadgeButtonField as UploadBadgeButtonField }
